export const resourceTitle = "Cadastro de depósito";
export const resourceSingularName = "Depósito";
export const resourcePluralName = "Depósitos";

// @todo: review endpoint
export const resourceKey = "endereco/deposito";

export const idKey = "id";

export const headers = [
    { label: 'SELECIONAR', key: 'checkbox', isVisible: true },
    { label: 'ID', key: 'id', isVisible: true },
    { label: 'Título', key: 'titulo', isVisible: true },
    { label: 'Motorista', key: 'motorista', isVisible: true },
    { label: 'Placa', key: 'placa', isVisible: true },
    { label: 'Transportadora', key: 'transportadora', isVisible: true },
    { label: 'Pagamento', key: 'pagamento', isVisible: true },
    { label: 'Tipo Janela', key: 'tipoJanela', isVisible: true },
    { label: 'Janela', key: 'janela', isVisible: true },
    { label: 'Data Prevista', key: 'dataPrevista', isVisible: true },
    { label: 'Obs', key: 'obs', isVisible: true },
  ];

  export const mockData = [
      {
        titulo: 'DI 394172 P CIAL GRANDE MISTO AMARELO 4507502083 / 14 PALETES DE GPO',
        motorista: 'João Silva',
        placa: 'ABC-1234',
        transportadora: 'TransExpress',
        pagamento: 'Pago',
        tipoJanela: 'Manhã',
        janela: '08:00-12:00',
        dataPrevista: '23/03/2023',
        obs: 'DI 394172 P CIAL CAMPINA GRANDE - GPO',
      },
      {
        titulo: 'VEÍCULO SEM CONV IMTRAÇÃO',
        motorista: 'Maria Oliveira',
        placa: 'XYZ-5678',
        transportadora: 'LogiMais',
        pagamento: 'Pendente',
        tipoJanela: 'Tarde',
        janela: '13:00-17:00',
        dataPrevista: '24/03/2023',
        obs: 'GPO - SECO / PAR ARBAALI FROM YEMEN ???/ ??? BURACID???',
      },
      {
        titulo: 'Exemplo Título SECO',
        motorista: 'Carlos Souza',
        placa: 'DEF-9012',
        transportadora: 'Rápido Entrega',
        pagamento: 'Pago',
        tipoJanela: 'Integral',
        janela: '09:00-18:00',
        dataPrevista: '25/02/2025',
        obs: 'ROTA SECO',
      },
    ];